import { render, staticRenderFns } from "./auditorDashboard.vue?vue&type=template&id=68066cb7"
import script from "./auditorDashboard.vue?vue&type=script&lang=js"
export * from "./auditorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports